import axios from "./orderInstance"
import { toast } from "react-toastify"
export default async (orderId: string,lineItemsReq:any) => {
  try {
    const response: any = await axios.post(`/orders/${orderId}/jobs/reprocess/line-items`,lineItemsReq)
    return response.data
  } catch (error) {
    return null
  }
}
